import {
  Menu,
  MenuButton,
  MenuList,
  Input,
  forwardRef,
} from "@chakra-ui/react";
import { format } from "date-fns";
import React, { useState } from "react";
import { Calendar } from "react-date-range";

interface IDateInputProps {
  initialValue?: Date;
  name: string;
}
export default forwardRef(function DateInput(
  { initialValue, name }: IDateInputProps,
  ref
) {
  const [date, setDate] = useState<Date>(initialValue || new Date());

  return (
    <Menu>
      <MenuButton type="button">
        <Input
          type="date"
          name={name}
          bg="white"
          maxW="200px"
          value={format(date, "yyyy-MM-dd")}
          id={name}
          ref={ref}
        />
      </MenuButton>
      <MenuList>
        <Calendar
          //@ts-ignore
          color="#2CB9A9"
          date={date}
          onChange={(date) => setDate(date as Date)}
        />
      </MenuList>
    </Menu>
  );
});
